import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  confirmPaymentRequest: null,
  removePaymentMethod: null,
  selectPaymentMethod: null,
  selectPaymentRequest: ['payload'],
  setOrderReferenceId: ['payload'],
}, { prefix: '[AMAZON] ' });
